import queryFieldKeyToDataType from '@opsbase/lib-data-queryfield/helpers/queryFieldKeyToDataType';
import QueryFieldRegistry from '@opsbase/lib-data-queryfield/QueryFieldRegistry';
import useCallforward from '@opsbase/react-hooks/useCallforward';
import DataPill from '@opsbase/web-chips/DataPill';
import React from 'react';
function PlaceFiltersList(props) {
    const { filters = [], onRemoveFilter } = props;
    const handleDeleteFilter = useCallforward((filter) => () => {
        onRemoveFilter(filter);
    }, [onRemoveFilter]);
    return (React.createElement(React.Fragment, null, filters
        .filter(fb => !fb.hidden)
        .map((fb, i) => {
        const queryField = QueryFieldRegistry[fb.queryFieldKey];
        return (React.createElement(DataPill, { style: { marginLeft: 4 }, key: 'filter' + i, type: queryFieldKeyToDataType(queryField.key), color: fb.color, label: queryField.label(), value: fb.title, onDelete: handleDeleteFilter(fb) }));
    })));
}
export default PlaceFiltersList;
